import { createSlice } from "@reduxjs/toolkit";
import { apiCallBegan } from "../api";

const urlPrefix = "/api/v2/chatapp/user-chat/checkAgentCanMsg";
const businessHoursChatPermissionURLPrefix =
  "/api/v2/chatapp/user-chat/checkInTimeframe";

interface IChatConfigurations {
  freeText?: Number;
  template?: Number;
  isAllowedToChatPerOfficeHoursConfig?: Boolean;
  optStatus?: Boolean;
  userMessaged?: Boolean;
  templateSMS?: Number;
}

const initailState: IChatConfigurations = {
  freeText: 0,
  template: 0,
  isAllowedToChatPerOfficeHoursConfig: false,
  optStatus: false,
  userMessaged: false,
  templateSMS: 0
};

const slice = createSlice({
  name: "chatConfigurations",
  initialState: initailState,
  reducers: {
    chatConfigurationsReceived: (state, action) => {
      const data = action.payload;
      let newState: IChatConfigurations = {};

      if (data.hasOwnProperty("freeText")) {
        newState.freeText = data.freeText;
      }
      if (data.hasOwnProperty("template")) {
        newState.template = data.template;
      }
      if (data.hasOwnProperty("isAllowedToChatPerOfficeHoursConfig")) {
        newState.isAllowedToChatPerOfficeHoursConfig =
          data.isAllowedToChatPerOfficeHoursConfig;
      }
      if (data.hasOwnProperty("optStatus")) {
        newState.optStatus = data.optStatus;
      }
      if (data.hasOwnProperty("userMessaged")) {
        newState.userMessaged = data.userMessaged;
      }
      if (data.hasOwnProperty("templateSMS")) {
        newState.templateSMS = data.templateSMS;
      }

      state = { ...state, ...newState };

      return state;
    },
    updateLockCondition: (state, action) => {
      state = action.payload;
      return state;
    }
  }
});

export const { chatConfigurationsReceived, updateLockCondition } =
  slice.actions;

export const loadChatConfigurations = (payload: any) => {
  return apiCallBegan({
    url: `${urlPrefix}/?chatId=${payload.chatId}&senderType=agent`,
    method: "GET",
    onSuccess: chatConfigurationsReceived.type,
    resolve: payload.resolve,
    reject: payload.reject
  });
};

export const loadBusinessHoursChatPermission = (payload: any) => {
  return apiCallBegan({
    url: `${businessHoursChatPermissionURLPrefix}/?chatId=${payload.chatId}`,
    method: "GET",
    onSuccess: chatConfigurationsReceived.type,
    resolve: payload.resolve,
    reject: payload.reject
  });
};

export default slice.reducer;
